/* The Price map (AdminPrices.dc.html), Reports and the Audit log (no board: the admin boards' master
   brand look). Every colour is a token (styles/tokens.css); small grey text never lighter than
   --shell-ink-60. Under 760px the tables stack (styles/admin.css) and the 2 panels sit 1 above the other. */

/* ---- The table: 1 row per Stripe price ------------------------------------------------------------ */
.pm-map { border-radius: 14px; border: 1px solid var(--shell-ink-10); overflow: hidden; background: var(--shell-bg); }
.pm-table .ad-tr { padding: 13px 22px; }
.pm-table .ad-thead .ad-tr { padding: 12px 22px; }
.pm-table .ad-td { font-size: 13px; }
.pm-table .ad-tbody .ad-tr:last-child { border-bottom: 1px solid var(--shell-ink-06); }
.pm-price { display: flex; align-items: flex-start; gap: 9px; }
.pm-price .ad-dot { margin-top: 5px; }
.pm-price-text { display: flex; flex-direction: column; gap: 1px; min-width: 0; }
.pm-price-amount { font-size: 14px; font-weight: 800; }
.pm-price-amount--quiet { font-weight: 700; color: var(--shell-ink-60); }
.pm-price-label { font-size: 13px; color: var(--shell-ink-60); }
.pm-from { color: var(--shell-ink-72); }
.pm-quiet { color: var(--shell-ink-60); }
.pm-opens { font-weight: 700; }
.pm-rule { display: flex; flex-direction: column; gap: 2px; line-height: 1.5; color: var(--shell-ink-72); }
.pm-rule-line { font-size: 12px; color: var(--shell-ink-66); }
.pm-rule-warn { font-weight: 700; color: var(--shell-ink); }
.pm-status { display: flex; flex-direction: column; align-items: flex-start; gap: 6px; }
.pm-chip {
  height: 26px; padding: 0 10px; border-radius: 13px; font-size: 12px; font-weight: 800; white-space: nowrap;
  display: inline-flex; align-items: center; border: 1px solid var(--shell-ink-07); background: var(--shell-ink-07); color: var(--shell-ink);
}
.pm-chip--not_in_hub, .pm-chip--by_hand { background: var(--shell-bg); border-color: var(--shell-ink-20); }
.pm-chip--waiting { background: var(--shell-bg); border-color: var(--shell-ink); }
.pm-edit {
  border: none; background: none; padding: 0; font: inherit; font-size: 12px; font-weight: 700; color: var(--shell-ink);
  text-decoration: underline; cursor: pointer;
}
.pm-foot { padding: 12px 22px; font-size: 13px; line-height: 1.5; color: var(--shell-ink-62); }

/* ---- Mismatches and the rules, side by side ------------------------------------------------------- */
.pm-grid { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 22px; align-items: start; }
.pm-panel {
  border-radius: 14px; border: 1px solid var(--shell-ink-10); padding: 20px 22px; background: var(--shell-bg);
  display: flex; flex-direction: column; gap: 14px; min-width: 0;
}
.pm-panel-head { display: flex; justify-content: space-between; align-items: baseline; gap: 4px 12px; flex-wrap: wrap; }
.pm-panel-title { margin: 0; font-size: 18px; font-weight: 800; }
.pm-panel-aside { font-size: 13px; color: var(--shell-ink-60); }
.pm-issue {
  padding: 14px 16px; border-radius: 10px; background: var(--shell-bg); border: 1px solid var(--shell-ink);
  display: flex; flex-direction: column; gap: 8px; min-width: 0;
}
.pm-issue--done { background: var(--shell-ink-03); border-color: var(--shell-ink-08); }
.pm-issue-kind { font-size: 12px; font-weight: 800; letter-spacing: 0.06em; text-transform: uppercase; color: var(--shell-ink-60); }
.pm-issue-text { font-size: 14px; line-height: 1.55; overflow-wrap: anywhere; }
.pm-issue-done { font-size: 13px; font-weight: 800; line-height: 1.5; }
.pm-issue-note { font-size: 13px; line-height: 1.5; color: var(--shell-ink-66); }
.pm-issue-actions { display: flex; gap: 8px; flex-wrap: wrap; align-items: center; }
.pm-inline { display: flex; flex-direction: column; gap: 10px; }
.pm-none { margin: 0; }
.pm-none .ad-empty { padding: 4px 0; }
.pm-match { display: flex; flex-direction: column; gap: 10px; }
.pm-match .ad-search { width: 100%; }
.pm-match-none { margin: 0; font-size: 13px; color: var(--shell-ink-66); }
.pm-match-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; border-top: 1px solid var(--shell-ink-08); }
.pm-match-list li {
  display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 8px 0; border-bottom: 1px solid var(--shell-ink-08);
}
.pm-match-who { display: flex; flex-direction: column; min-width: 0; }
.pm-match-name { font-size: 14px; font-weight: 700; }
.pm-match-email { font-size: 13px; color: var(--shell-ink-60); overflow-wrap: anywhere; }
.pm-rules { margin: 0; display: flex; flex-direction: column; }
.pm-rules-row {
  display: grid; grid-template-columns: 150px minmax(0, 1fr); gap: 14px; padding: 10px 0; border-bottom: 1px solid var(--shell-ink-06);
}
.pm-rules-row dt { font-size: 13px; font-weight: 800; }
.pm-rules-row dd { margin: 0; font-size: 13px; line-height: 1.55; color: var(--shell-ink-72); }
.pm-dialog-lede { font-size: 14px; }
.pm-due { gap: 12px; }

@media (max-width: 1100px) {
  .pm-grid { grid-template-columns: minmax(0, 1fr); }
}

/* ---- Reports ------------------------------------------------------------------------------------ */
.rp-filters { display: flex; flex-direction: column; gap: 14px; }
.rp-filter-row { display: flex; flex-wrap: wrap; gap: 12px 20px; align-items: flex-end; }
.rp-filter-row .ad-field { width: 220px; max-width: 100%; }
.rp-count { font-size: 14px; color: var(--shell-ink-66); margin: 0; }
.rp-count strong { color: var(--shell-ink); }
.rp-num { font-variant-numeric: tabular-nums; }
.rp-left-out { margin: 0; font-size: 13px; line-height: 1.5; color: var(--shell-ink-66); }

/* ---- The Audit log --------------------------------------------------------------------------------- */
.au-filters { display: flex; flex-direction: column; gap: 14px; }
.au-filter-row { display: flex; flex-wrap: wrap; gap: 12px 20px; align-items: flex-end; }
.au-filter-row .ad-field { width: 220px; max-width: 100%; }
.au-person { display: flex; flex-direction: column; gap: 8px; width: 340px; max-width: 100%; }
.au-picked { display: inline-flex; align-items: center; gap: 10px; flex-wrap: wrap; font-size: 14px; font-weight: 700; }
.au-what { display: flex; flex-direction: column; gap: 2px; }
.au-what-action { font-weight: 700; }
.au-what-detail { font-size: 13px; color: var(--shell-ink-66); overflow-wrap: anywhere; }
.au-about { display: flex; flex-direction: column; gap: 2px; }
.au-about a { color: var(--shell-ink); font-weight: 700; }
.au-when { font-size: 13px; color: var(--shell-ink-66); white-space: nowrap; }
.au-more { display: flex; justify-content: center; padding: 4px 0; }

@media (max-width: 760px) {
  .pm-table .ad-tr { padding: 14px 16px; }
  .pm-panel { padding: 18px 16px; }
  .pm-rules-row { grid-template-columns: minmax(0, 1fr); gap: 4px; }
  .pm-foot { padding: 12px 16px; }
  .pm-status { flex-direction: row; align-items: center; gap: 12px; }
  /* at least 24px to tap (item 178) */
  .au-about a { display: flex; align-items: center; min-height: 24px; }
  .pm-edit { display: inline-flex; align-items: center; justify-content: center; min-height: 24px; min-width: 24px; padding: 0 3px; }
  .rp-filter-row .ad-field, .au-filter-row .ad-field { width: 100%; }
  .au-when { white-space: normal; }
  /* a stacked row leads with what happened, and drops a column with nothing in it */
  .au-table .ad-td--primary { order: -1; }
  .au-table .ad-td:empty, .rp-table .ad-td:empty { display: none; }
}
